<template>
  <div>
    <div class="row justify-content-md-center" v-cloak v-if="!state.loaded">
      <div class="col col-lg-2"></div>
      <div class="col-md-auto mt-20">
        <rotate-square5></rotate-square5>
      </div>
      <div class="col col-lg-2"></div>
    </div>
    <div class="card card-body printableArea" v-else>
      <h3>
        <b>Detail</b>
        <span class="pull-right">
          <button type="button" @click="goBack()" class="btn btn-inverse" title="Kembali">Kembali</button>
        </span>
      </h3>
      <hr>
      <div class="row">
        <div class="col-md-12 justify-content-md-center">
          <div class="col-md-6 pull-left">
            <small class="text-muted">Sebagai Induk</small>
            <h6>{{is_induk}}</h6>
            <small class="text-muted">Induk Klasifikasi</small>
            <h6>{{state.detail.induk_klasifikasi}}</h6>
            <small class="text-muted">Kode Klasifikasi</small>
            <h6>{{state.detail.code_classification}}</h6>
            <small class="text-muted">Nama Klasifikasi</small>
            <h6>{{state.detail.name_classification}}</h6>
            <!-- <small class="text-muted">Retensi Active</small>
            <h6>{{state.detail.retensi_aktif_text}}</h6>
            <small class="text-muted">Retensi Inactive</small>
            <h6>{{state.detail.retensi_inaktif_text}}</h6> -->
            <!-- <small class="text-muted">Type Surat</small>
            <h6>{{state.detail.type}}</h6> -->
            <!-- <small class="text-muted">Aksi Selanjutnya</small>
            <h6>{{state.detail.aksi_selanjutnya}}</h6> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RotateSquare5 } from "vue-loading-spinner";
export default {
  components: {
    RotateSquare5
  },
  computed: {
    base() {
      return this.baseUrl;
    },
    state() {
      return this.$store.state.clasificationdoc;
    },
    submitted() {
      return this.formatDate(this.state.detail.created_at);
    },
    modified() {
      return this.formatDate(this.state.detail.updated_at);
    },
    is_induk() {
      if(this.state.detail.induk_klasifikasi=='-'){
        return "Ya";
      } else {
        return "Tidak";
      }
    }

  },
  mounted() {
    this.detailLoad();
  },
  methods: {
    detailLoad() {
      const state = {
        loaded: false
      };
      this.$store.commit("clasificationdoc/STATE", state);
      this.$store.dispatch(
        "clasificationdoc/getClasificationDocById",
        this.$route.params
      );
    },
    goBack() {
      this.$store.dispatch("clasificationdoc/onCancel");
    }
  }
};
</script>
